import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

interface SettingsContextType {
  systemName: string;
  isLoading: boolean;
  refreshSettings: () => Promise<void>;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [systemName, setSystemName] = useState('Itororo SAC');
  const [isLoading, setIsLoading] = useState(true);

  const loadSettings = async () => {
    try {
      const settings = await api.getSettings();
      setSystemName(settings.systemName || 'Itororo SAC');
    } catch (error) {
      console.error('Failed to load settings:', error);
      // Fallback to default
      setSystemName('Itororo SAC');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const refreshSettings = async () => {
    setIsLoading(true);
    await loadSettings();
  };

  return (
    <SettingsContext.Provider value={{ systemName, isLoading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};
